export const authConfig = {
  actions: {
    userAuthentication: {
      sections: {
        userAuthentication: 'userAuthentication',
        authToken: 'authToken',
        authUser: 'authUser',
        superCredentials: 'superCredentials',
        tenantSelection: 'tenantSelection',
      },
    },
  },
};
